import _ from 'lodash';

export const getCookies = () => {
	let cookies = _(document.cookie)
		.split(';')
		.map(item => _.trim(item))
		.map(item => _.split(item, '='))
		.fromPairs()
		.value();

	return cookies;
};

export const getLicenseeTypes = (mlcUserGroups: any): string[] => {
	return _(mlcUserGroups)
		.filter(item => _.startsWith(item, 'wmMkLicensee'))
		.map(item => _.replace(item, 'wmMkLicensee', ''))
		.value();
};

export const getDisplayName = (adviserDetails: any): string => {
	let value;
	const {
		adviserFirstName,
		adviserCompanyName,
		firstName,
		lastName,
		customerNumber,
		adviserLastName,
		roles,
	} = adviserDetails;
	const displayName = `${convertStartingWordCapital(
		firstName
	)} ${convertStartingWordCapital(lastName)}`;
	if (isCsr(roles)) {
		value = `${displayName} (${customerNumber} ${adviserCompanyName ||
			adviserLastName})`;
	} else if (isOfficeUser(roles)) {
		value = `${displayName} (${customerNumber} ${adviserCompanyName ||
			adviserLastName})`;
	} else if (adviserFirstName) {
		value = `${displayName} (${customerNumber} ${convertStartingWordCapital(
			adviserLastName
		)} ${convertStartingWordCapital(adviserFirstName)})`;
	} else {
		value = `${displayName}`;
	}
	return _.truncate(value, {
		length: 35,
	});
};

export const isCsr = (mlcUserGroups: string[]) => {
	return _(mlcUserGroups).includes('wmMkCsr');
};

export const isOfficeUser = (mlcUserGroups: string[]) => {
	return _(mlcUserGroups).includes('wmMkOfficeUser');
};

export const convertStartingWordCapital = (
	name: string | null | undefined
): string => {
	if (name == null) {
		return '';
	}
	return name
		.split(' ')
		.map(_.capitalize)
		.join(' ');
};
